// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Income/IncomeTable.css */

.income-table-container {
  background-color: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
}

.income-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #F8FAFC;
  border-bottom: 1px solid #ECF0F1;
}

.income-header h4 {
  margin: 0;
  color: #2C3E50;
  font-size: 16px;
  font-weight: 600;
}

.add-income-btn {
  padding: 8px 16px;
  background-color: #3498DB;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-weight: 500;
}

.add-income-btn:hover {
  background-color: #2980B9;
}

/* Year tabs */
.year-tabs {
  display: flex;
  gap: 2px;
  padding: 0 16px;
  background: #ECF0F1;
  border-bottom: 2px solid #BDC3C7;
}

.year-tab {
  position: relative;
  padding: 12px 24px;
  border: none;
  background: transparent;
  font-size: 14px;
  color: #7F8C8D;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 6px 6px 0 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.year-tab:hover {
  color: #3498DB;
  background: rgba(52, 152, 219, 0.1);
}

.year-tab.active {
  color: #2C3E50;
  background: white;
  font-weight: 600;
  border: 2px solid #BDC3C7;
  border-bottom-color: white;
  margin-bottom: -2px;
}

.year-count {
  background: #3498DB;
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: 600;
}

.year-tab.active .year-count {
  background: #27AE60;
}

/* Loading state */
.income-loading {
  text-align: center;
  padding: 32px;
  color: #7F8C8D;
  font-size: 14px;
}

/* Empty state */
.no-incomes {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  color: #7F8C8D;
  background-color: white;
  gap: 12px;
}

.no-incomes-icon {
  font-size: 32px;
  opacity: 0.5;
}

.no-incomes .add-link {
  margin-top: 8px;
  padding: 8px 16px;
  background: none;
  border: 2px dashed #BDC3C7;
  color: #3498DB;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.no-incomes .add-link:hover {
  border-color: #3498DB;
  background: rgba(52, 152, 219, 0.05);
}

/* Table */
.income-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
}

.income-table th,
.income-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #ECF0F1;
}

.income-table th {
  background-color: #34495E;
  color: white;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.income-table th.amount-col {
  text-align: right;
  min-width: 120px;
}

.income-table th.actions-col {
  text-align: center;
  width: 100px;
}

.income-table tbody tr:hover {
  background-color: #F8FAFC;
}

/* Type cell */
.type-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.type-icon {
  font-size: 18px;
}

.type-label {
  font-weight: 500;
  color: #2C3E50;
}

/* Period cell */
.period-cell .period {
  font-size: 13px;
  color: #7F8C8D;
}

/* Amount cells */
.income-table .amount {
  text-align: right;
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  font-size: 13px;
  color: #2C3E50;
}

.income-table .taxable {
  color: #27AE60;
  font-weight: 600;
}

.income-table .abatement {
  font-size: 12px;
  color: #95A5A6;
}

/* Actions */
.income-table .actions {
  text-align: center;
  white-space: nowrap;
}

.income-table .edit-btn,
.income-table .delete-btn {
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  margin: 0 2px;
  background: #ECF0F1;
  transition: all 0.2s;
}

.income-table .edit-btn:hover {
  background-color: #3498DB;
  transform: scale(1.1);
}

.income-table .delete-btn:hover {
  background-color: #E74C3C;
  transform: scale(1.1);
}

/* Footer totals */
.income-table tfoot {
  background-color: #F8FAFC;
}

.income-table .totals-row td {
  border-top: 2px solid #34495E;
  padding: 16px;
}

.income-table .totals-row .taxable {
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Income/IncomeTable.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,qDAAqD;EACrD,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* src/components/Income/IncomeTable.css */\n\n.income-table-container {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.income-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  background: #F8FAFC;\n  border-bottom: 1px solid #ECF0F1;\n}\n\n.income-header h4 {\n  margin: 0;\n  color: #2C3E50;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.add-income-btn {\n  padding: 8px 16px;\n  background-color: #3498DB;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-weight: 500;\n}\n\n.add-income-btn:hover {\n  background-color: #2980B9;\n}\n\n/* Year tabs */\n.year-tabs {\n  display: flex;\n  gap: 2px;\n  padding: 0 16px;\n  background: #ECF0F1;\n  border-bottom: 2px solid #BDC3C7;\n}\n\n.year-tab {\n  position: relative;\n  padding: 12px 24px;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  color: #7F8C8D;\n  cursor: pointer;\n  transition: all 0.2s;\n  border-radius: 6px 6px 0 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.year-tab:hover {\n  color: #3498DB;\n  background: rgba(52, 152, 219, 0.1);\n}\n\n.year-tab.active {\n  color: #2C3E50;\n  background: white;\n  font-weight: 600;\n  border: 2px solid #BDC3C7;\n  border-bottom-color: white;\n  margin-bottom: -2px;\n}\n\n.year-count {\n  background: #3498DB;\n  color: white;\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-weight: 600;\n}\n\n.year-tab.active .year-count {\n  background: #27AE60;\n}\n\n/* Loading state */\n.income-loading {\n  text-align: center;\n  padding: 32px;\n  color: #7F8C8D;\n  font-size: 14px;\n}\n\n/* Empty state */\n.no-incomes {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  color: #7F8C8D;\n  background-color: white;\n  gap: 12px;\n}\n\n.no-incomes-icon {\n  font-size: 32px;\n  opacity: 0.5;\n}\n\n.no-incomes .add-link {\n  margin-top: 8px;\n  padding: 8px 16px;\n  background: none;\n  border: 2px dashed #BDC3C7;\n  color: #3498DB;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.no-incomes .add-link:hover {\n  border-color: #3498DB;\n  background: rgba(52, 152, 219, 0.05);\n}\n\n/* Table */\n.income-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: white;\n}\n\n.income-table th,\n.income-table td {\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 1px solid #ECF0F1;\n}\n\n.income-table th {\n  background-color: #34495E;\n  color: white;\n  font-weight: 500;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.income-table th.amount-col {\n  text-align: right;\n  min-width: 120px;\n}\n\n.income-table th.actions-col {\n  text-align: center;\n  width: 100px;\n}\n\n.income-table tbody tr:hover {\n  background-color: #F8FAFC;\n}\n\n/* Type cell */\n.type-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.type-icon {\n  font-size: 18px;\n}\n\n.type-label {\n  font-weight: 500;\n  color: #2C3E50;\n}\n\n/* Period cell */\n.period-cell .period {\n  font-size: 13px;\n  color: #7F8C8D;\n}\n\n/* Amount cells */\n.income-table .amount {\n  text-align: right;\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  font-size: 13px;\n  color: #2C3E50;\n}\n\n.income-table .taxable {\n  color: #27AE60;\n  font-weight: 600;\n}\n\n.income-table .abatement {\n  font-size: 12px;\n  color: #95A5A6;\n}\n\n/* Actions */\n.income-table .actions {\n  text-align: center;\n  white-space: nowrap;\n}\n\n.income-table .edit-btn,\n.income-table .delete-btn {\n  padding: 6px 10px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  margin: 0 2px;\n  background: #ECF0F1;\n  transition: all 0.2s;\n}\n\n.income-table .edit-btn:hover {\n  background-color: #3498DB;\n  transform: scale(1.1);\n}\n\n.income-table .delete-btn:hover {\n  background-color: #E74C3C;\n  transform: scale(1.1);\n}\n\n/* Footer totals */\n.income-table tfoot {\n  background-color: #F8FAFC;\n}\n\n.income-table .totals-row td {\n  border-top: 2px solid #34495E;\n  padding: 16px;\n}\n\n.income-table .totals-row .taxable {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
